export default __webpack_public_path__ + "static/media/right_tick.80c7e994.svg";